// extracted by mini-css-extract-plugin
export var completionBody = "_je-2";
export var completionCard = "_je-0";
export var completionFooter = "_je-3";
export var completionTitle = "_je-1";